import { Check } from "lucide-react";
import "./extension.css";
import raindrop from "../../../assets/raindrop.webp";

const CHROME_STORE_URL = "https://chromewebstore.google.com/";

/* The Chrome mark, drawn rather than imported so it stays sharp at both the
   16px in the button and the 20px in the store chip. Three 120° wedges with
   a hairline gap, then the white ring and the blue centre. */
const ChromeMark = ({ size = 18 }) => (
  <svg
    className="s-ext-chrome"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M50 50 L52.181 0.048 A50 50 0 0 1 94.351 73.088 Z" fill="#EA4335" />
    <path d="M50 50 L92.170 76.865 A50 50 0 0 1 7.830 76.865 Z" fill="#FBBC04" />
    <path d="M50 50 L5.649 73.088 A50 50 0 0 1 47.819 0.048 Z" fill="#34A853" />
    <circle cx="50" cy="50" r="23" fill="#ffffff" />
    <circle cx="50" cy="50" r="19" fill="#4285F4" />
  </svg>
);

/* The fields the extension fills for you, shown being filled. */
const filled = [
  { label: "First name", value: "Jordan" },
  { label: "Last name", value: "Ellis" },
  { label: "Email", value: "jordan.ellis@school.edu" },
  { label: "Phone", value: "(617) 555-0148" },
  { label: "School", value: "Emory University" },
  { label: "Resume", value: "Jordan-Ellis-Resume.pdf" },
];

const Extension = () => (
  <section className="s-section s-extension">
    <div className="home-container">
      <div className="s-extension-panel">
        <div className="s-extension-grid">
          <div className="s-extension-copy">
            <span className="s-ext-store">
              <ChromeMark size={17} />
              Chrome Web Store
            </span>

            <h2 className="s-extension-title">
              Stop retyping the same application
            </h2>

            <p className="s-extension-text">
              The RAIN Chrome extension fills in your name, contact details,
              school and resume on any application form, and drops the role
              straight into your tracker while you are still on the page.
            </p>

            <a
              className="s-extension-btn"
              href={CHROME_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ChromeMark size={18} />
              Add to Chrome for free
            </a>

            <span className="s-ext-note">
              Free, and it works on any application form.
            </span>
          </div>

          {/* A small mock of the extension at work, built in markup so it
              stays sharp and picks up the page's own tokens. */}
          <div className="s-extension-visual" aria-hidden="true">
            <div className="s-ext-window">
              <div className="s-ext-bar">
                <span className="s-ext-dot" />
                <span className="s-ext-dot" />
                <span className="s-ext-dot" />
                <span className="s-ext-url">careers.company.com/apply</span>
                <img width={1600} height={1600} decoding="async" src={raindrop} alt="" className="s-ext-pin" />
              </div>

              <div className="s-ext-body">
                <p className="s-ext-heading">Application</p>
                {filled.map(({ label, value }) => (
                  <div className="s-ext-field" key={label}>
                    <span className="s-ext-label">{label}</span>
                    <span className="s-ext-value">
                      {value}
                      <Check size={13} strokeWidth={3} />
                    </span>
                  </div>
                ))}
              </div>
            </div>

            <span className="s-ext-badge">
              <img width={1600} height={1600} decoding="async" src={raindrop} alt="" />
              Autofilled by RAIN
            </span>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default Extension;
